'use client';

import { Accessibility, Eye, Keyboard, Volume2, ArrowLeft } from 'lucide-react';
import Link from 'next/link';

export default function AccessibilityPage() {
 return (
 <div className="min-h-screen bg-black text-neutral-200 font-sans selection:bg-blue-500/30">
 <div className="p-8 pt-16">
 {/* Back Link */}
 <Link
 href="/"
 className="inline-flex items-center gap-2 text-zinc-400 hover:text-purple-400 transition-colors mb-8"
 >
 <ArrowLeft size={16} />
 Back to Home
 </Link>

 {/* Header */}
 <div className="mb-8">
 <div className="flex items-center gap-3 mb-2">
 <Accessibility className="h-8 w-8 text-purple-400"/>
 <h1 className="text-3xl font-bold text-white">Accessibility</h1>
 </div>
 <p className="text-neutral-400 mt-1">Our commitment to making this platform accessible to everyone</p>
 </div>

 {/* Accessibility Features Cards */}
 <div className="grid gap-4 md:grid-cols-2">
 <div className="border border-neutral-800 rounded-lg bg-neutral-900/50 p-6 hover:border-neutral-700 transition-colors">
 <div className="w-12 h-12 bg-purple-500/10 rounded-lg flex items-center justify-center mb-4">
 <Keyboard className="h-6 w-6 text-purple-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Keyboard Navigation</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Full keyboard support for navigating and interacting with all features.
 </p>
 <span className="text-purple-400 text-sm font-medium inline-flex items-center gap-1">
 Coming Soon
 </span>
 </div>

 <div className="border border-neutral-800 rounded-lg bg-neutral-900/50 p-6 hover:border-neutral-700 transition-colors">
 <div className="w-12 h-12 bg-blue-500/10 rounded-lg flex items-center justify-center mb-4">
 <Eye className="h-6 w-6 text-blue-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Screen Reader Support</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Compatible with popular screen readers for visually impaired users.
 </p>
 <span className="text-blue-400 text-sm font-medium inline-flex items-center gap-1">
 Coming Soon
 </span>
 </div>

 <div className="border border-neutral-800 rounded-lg bg-neutral-900/50 p-6 hover:border-neutral-700 transition-colors">
 <div className="w-12 h-12 bg-emerald-500/10 rounded-lg flex items-center justify-center mb-4">
 <Volume2 className="h-6 w-6 text-emerald-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Audio Descriptions</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Audio descriptions for visual content and interface elements.
 </p>
 <span className="text-emerald-400 text-sm font-medium inline-flex items-center gap-1">
 Coming Soon
 </span>
 </div>

 <div className="border border-neutral-800 rounded-lg bg-neutral-900/50 p-6 hover:border-neutral-700 transition-colors">
 <div className="w-12 h-12 bg-amber-500/10 rounded-lg flex items-center justify-center mb-4">
 <Accessibility className="h-6 w-6 text-amber-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">WCAG Compliance</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Working toward WCAG 2.1 AA compliance for web accessibility standards.
 </p>
 <span className="text-amber-400 text-sm font-medium inline-flex items-center gap-1">
 In Progress
 </span>
 </div>
 </div>

 {/* Statement Section */}
 <div className="mt-8 border border-neutral-800 rounded-lg bg-neutral-900/50 p-8 text-center">
 <h2 className="text-xl font-semibold text-white mb-2">Accessibility Statement</h2>
 <p className="text-neutral-400 max-w-2xl mx-auto">
 We are committed to ensuring digital accessibility for people with disabilities.
 We are continually improving the user experience for everyone and applying
 relevant accessibility standards. Contact your administrator if you encounter
 any accessibility barriers.
 </p>
 </div>
 </div>
 </div>
 );
}
